import { SAVE_H4FORMS_SUCCESS,SAVE_H4FORMS_FAILED , SAVE_H4FORMS_STARTED,
    UPDATE_H4FORMS_SUCCESS,UPDATE_H4FORMS_FAILED,UPDATE_H4FORMS_STARTED,
    GET_H4FORMS_SUCCESS,GET_H4FORMS_FAILED,GET_H4FORMS_STARTED,

    SAVE_H4FORMSTRACKING_SUCCESS,SAVE_H4FORMSTRACKING_FAILED , SAVE_H4FORMSTRACKING_STARTED,
    UPDATE_H4FORMSTRACKING_SUCCESS,UPDATE_H4FORMSTRACKING_FAILED,UPDATE_H4FORMSTRACKING_STARTED,
    GET_H4FORMSTRACKING_SUCCESS,GET_H4FORMSTRACKING_FAILED,GET_H4FORMSTRACKING_STARTED,

    GET_H4FORMS539APDF_STARTED,GET_H4FORMS539APDF_SUCCESS,GET_H4FORMS539APDF_FAILED
} from '../actions/VisaCareH4Case';

  
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};

export const visaCareH4FormData = (state = intialData, action: any) => {
   
    switch (action.type) {
      case SAVE_H4FORMS_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_H4FORMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_H4FORMS_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case UPDATE_H4FORMS_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_H4FORMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_H4FORMS_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case GET_H4FORMS_STARTED:  
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_H4FORMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_H4FORMS_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      default:
          return state;
      }
      
  }


  export const visaCareH4FormTrackingData = (state = intialData, action: any) => {
 
    switch (action.type) {
      case SAVE_H4FORMSTRACKING_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_H4FORMSTRACKING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_H4FORMSTRACKING_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case UPDATE_H4FORMSTRACKING_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_H4FORMSTRACKING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_H4FORMSTRACKING_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case GET_H4FORMSTRACKING_STARTED:  
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_H4FORMSTRACKING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_H4FORMSTRACKING_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      default:
          return state;
      }
      
  }

  export const h4FormPdfSubmitData = (state = intialData, action: any) => {
    switch (action.type) {
      case GET_H4FORMS539APDF_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_H4FORMS539APDF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_H4FORMS539APDF_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      
      default:
          return state;
      }
      
  }